// extracted by mini-css-extract-plugin
module.exports = {"termsOfService":"Terms_termsOfService__3Hcn0","popIn":"Terms_popIn__2Eyda","termsOfServiceInner":"Terms_termsOfServiceInner__2QxHJ","closeTerms":"Terms_closeTerms__3gUvO"};